export default __webpack_public_path__ + "static/media/Penguin.4c50261e.png";